import _Object$keys from 'babel-runtime/core-js/object/keys';
import _typeof from 'babel-runtime/helpers/typeof';
import is from './is';

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @param {any} x
 * @param {any} y
 * @returns {boolean}
 */

function shallowEqual(x, y) {
  if (is(x, y)) {
    return true;
  }

  if ((typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object' || x === null || (typeof y === 'undefined' ? 'undefined' : _typeof(y)) !== 'object' || y === null) {
    return false;
  }

  var xKeys = _Object$keys(x);
  var yKeys = _Object$keys(y);

  if (xKeys.length !== yKeys.length) {
    return false;
  }

  for (var i = 0, len = xKeys.length; i < len; i++) {
    var key = xKeys[i];
    if (!hasOwnProperty.call(y, key) || !is(x[key], y[key])) {
      return false;
    }
  }

  return true;
}

export default shallowEqual;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/utils/shallowEqual.js
// module id = 204
// module chunks = 0